import { render, staticRenderFns } from "./AuditoriaDadosDetalhada.vue?vue&type=template&id=3c8422b7&scoped=true"
import script from "./AuditoriaDadosDetalhada.vue?vue&type=script&lang=js"
export * from "./AuditoriaDadosDetalhada.vue?vue&type=script&lang=js"
import style0 from "./AuditoriaDadosDetalhada.vue?vue&type=style&index=0&id=3c8422b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8422b7",
  null
  
)

export default component.exports